<template>
    <div>
      <LoadingLayer/>
      <VerticalNav/>
      <Navbar/>
      <Home/>
      <About/>
      <Interest/>
      <InterestContent/>
      <Case/>
      <CaseContent/>
      <Footer/>
    </div>
</template>

<style scoped>
@import "../assets/css/bootstrap.min.css";
@import "../assets/css/bootstrap-theme.min.css";
@import "../assets/css/style.css";
@import "../assets/css/default.css";
</style>
<script>
// @ is an alias to /src
import LoadingLayer from '@/components/LoadingLayer.vue'
import VerticalNav from '@/components/VerticalNav.vue'
import Navbar from '@/components/Navbar.vue'
import Home from '@/components/Home.vue'
import About from '@/components/About.vue'
import Interest from '@/components/Interest.vue'
import InterestContent from '@/components/InterestContent.vue'
import Case from '@/components/Case.vue'
import CaseContent from '@/components/CaseContent.vue'
import Footer from '@/components/Footer.vue'

import '@/assets/js/modernizr.min.js';
import '@/assets/js/jquery.js';
import '@/assets/js/jquery.easing.1.3.js';
import '@/assets/js/bootstrap.min.js';
import '@/assets/js/skrollr.min.js';
import '@/assets/js/stellar.js';
import '@/assets/js/jquery.appear.js';
// import '@/assets/js/test.js';

export default {
  name: 'index',
  components: {
    LoadingLayer,
    VerticalNav,
    Navbar,
    Home,
    About,
    Interest,
    InterestContent,
    Case,
    CaseContent,
    Footer
  },
  mounted() {

    (function ($) {
    var isMobile = false;

    if (Modernizr.mq('only all and (max-width: 1024px)')) {
        isMobile = true;
        $(".carousel .item").css("height", "350px");
        $(".notransition").css("opacity", "1");
        $(".qrcode").css("background", "none");
        $(".vrone").attr("data-toggle", "");
    }

     /*===================================================================================*/
    /*	加载全景
     /*===================================================================================*/
    var frameload = $("#frameload");
    if (frameload.length) {
        var winHeight = 0;
        //获取窗口高度
        if (window.innerHeight) {
            winHeight = window.innerHeight;
        } else if ((document.body) && (document.body.clientHeight)) {
            winHeight = document.body.clientHeight;
        }
        //通过深入Document内部对body进行检测，获取窗口高度
        if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
            winHeight = document.documentElement.clientHeight;
        }
        // console.log(winHeight);
        frameload.find("div").eq(0).css("height", winHeight);
        frameload.find("img").eq(0).css("marginTop", winHeight / 2);
        frameload.find("div").eq(1).css("height", winHeight);
    }
    
    /*===================================================================================*/
    /*	缓慢滑动
     /*===================================================================================*/
    $('.smooth').click(function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
        return false;
    });
    /*===================================================================================*/
    /*	nav视差动画skrollr
     /*===================================================================================*/
    var s = skrollr;
    var sActive = false;
    if ($(window).width() > 767) {
        s.init({
            mobileCheck: function () {
                return false;
            }
        });
        sActive = true;
    }
    $(window).on('resize', function () {
        if ($(window).width() < 767 && sActive) {
            s.init().destroy();
            sActive = false;
        }
        else if ($(window).width() > 767) {
            s.init({
                mobileCheck: function () {
                    return false;
                }
            });
            sActive = true;
        }
    });

    /*===================================================================================*/
    /*	 弹出框fancybox fancybox
     /*===================================================================================*/
    //jQuery(".fancybox").fancybox();

    if (isMobile == false) {
        /*===================================================================================*/
        /*	滑动监听scroll menu appear
         /*===================================================================================*/
        var appear = $(".appear");
        appear.appear();
        appear.on("appear", function () {
            var id = $(this).attr("id");
            jQuery('.cd-vertical-nav a').removeClass('active');
            jQuery(".cd-vertical-nav a[href='#" + id + "']").addClass("active");
        });

        var timelineBlocks = $('.cd-timeline-block'),
            offset = 0.8;
        /*===================================================================================*/
        /*	侧边栏
         /*===================================================================================*/
        //hide timeline blocks which are outside the viewport
        hideBlocks(timelineBlocks, offset);

        //on scolling, show/animate timeline blocks when enter the viewport
        $(window).on('scroll', function () {
            (!window.requestAnimationFrame)
                ? setTimeout(function () {
                showBlocks(timelineBlocks, offset);
            }, 100)
                : window.requestAnimationFrame(function () {
                showBlocks(timelineBlocks, offset);
            });
        });

        function hideBlocks(blocks, offset) {
            blocks.each(function () {
                ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
            });
        }

        function showBlocks(blocks, offset) {
            blocks.each(function () {
                ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
            });
        }

        /*===================================================================================*/
        /*	视差parallax
         /*===================================================================================*/
        $(window).stellar({
            responsive: true,
            scrollProperty: 'scroll',
            parallaxElements: false,
            horizontalScrolling: false,
            horizontalOffset: 0,
            verticalOffset: 0
        });
        /*===================================================================================*/
        /*	动画效果
         /*===================================================================================*/
        jQuery('.animated').appear();

        jQuery(document.body).on('appear', '.fade', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('anim-fade')
            });
        });

        jQuery(document.body).on('appear', '.fadeInUpNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInUp')
            });
        });
        jQuery(document.body).on('appear', '.fadeInDownNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInDown')
            });
        });
        jQuery(document.body).on('appear', '.fadeInLeftNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInLeft')
            });
        });
        jQuery(document.body).on('appear', '.fadeInRightNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInRight')
            });
        });

        jQuery(document.body).on('appear', '.fadeInUpBigNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInUpBig')
            });
        });
        jQuery(document.body).on('appear', '.fadeInDownBigNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInDownBig')
            });
        });
        jQuery(document.body).on('appear', '.fadeInLeftBigNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInLeftBig')
            });
        });
        jQuery(document.body).on('appear', '.fadeInRightBigNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeInRightBig')
            });
        });
        jQuery(document.body).on('appear', '.fadeInNow', function () {
            jQuery(this).each(function () {
                jQuery(this).addClass('fadeIn')
            });
        });
        $.force_appear()
    }
    /*===================================================================================*/
    /*	返回顶部
     /*===================================================================================*/
    !function (a, b, c) {
        a.fn.scrollUp = function (b) {
            a.data(c.body, "scrollUp") || (a.data(c.body, "scrollUp", !0), a.fn.scrollUp.init(b))
        }, a.fn.scrollUp.init = function (d) {
            var e = a.fn.scrollUp.settings = a.extend({}, a.fn.scrollUp.defaults, d),
                f = e.scrollTitle ? e.scrollTitle : e.scrollText,
                g = a("<a/>", {
                    id: e.scrollName,
                    href: "#header", /*,
                     title: f*/
                    class: "scrollup"
                }).appendTo("body");
            e.scrollImg || g.html(e.scrollText), g.css({
                display: "none",
                zIndex: e.zIndex
            }), e.activeOverlay && a("<div/>", {
                id: e.scrollName + "-active"
            }).css({
                position: "absolute",
                top: e.scrollDistance + "px",
                width: "100%",
                borderTop: "1px dotted" + e.activeOverlay,
                zIndex: e.zIndex
            }).appendTo("body");
            var scrollEvent = a(b).scroll(function () {
              var scrollDis = "top" === e.scrollFrom ? e.scrollDistance : a(c).height() - a(b).height() - e.scrollDistance;
                switch (scrollDis, e.animation) {
                    case "fade":
                        a(a(b).scrollTop() > scrollDis ? g.fadeIn(e.animationInSpeed) : g.fadeOut(e.animationOutSpeed));
                        break;
                    case "slide":
                        a(a(b).scrollTop() > scrollDis ? g.slideDown(e.animationInSpeed) : g.slideUp(e.animationOutSpeed));
                        break;
                    default:
                        a(a(b).scrollTop() > scrollDis ? g.show(0) : g.hide(0))
                }
            });
            g.click(function (b) {
                b.preventDefault(), a("html, body").animate({
                    scrollTop: 0
                }, e.scrollSpeed, e.easingType)
            })
        }, a.fn.scrollUp.defaults = {
            scrollName: "scrollUp",
            scrollDistance: 300,
            scrollFrom: "top",
            scrollSpeed: 300,
            easingType: "linear",
            animation: "fade",
            animationInSpeed: 200,
            animationOutSpeed: 200,
            scrollText: "Scroll to top",
            scrollTitle: !1,
            scrollImg: !1,
            activeOverlay: !1,
            zIndex: 2147483647
        }, a.fn.scrollUp.destroy = function (d) {
            a.removeData(c.body, "scrollUp"), a("#" + a.fn.scrollUp.settings.scrollName).remove(), a("#" + a.fn.scrollUp.settings.scrollName + "-active").remove(), a.fn.jquery.split(".")[1] >= 7 ? a(b).off("scroll", d) : a(b).unbind("scroll", d)
        }, a.scrollUp = a.fn.scrollUp
    }(jQuery, window, document);
    $(document).ready(function () {
        $.scrollUp({
            scrollName: "scrollUp", // Element ID
            scrollDistance: 300, // Distance from top/bottom before showing element (px)
            scrollFrom: "top", // "top" or "bottom"
            scrollSpeed: 1000, // Speed back to top (ms)
            easingType: "easeInOutCubic", // Scroll to top easing (see http://easings.net/)
            animation: "fade", // Fade, slide, none
            animationInSpeed: 200, // Animation in speed (ms)
            animationOutSpeed: 200, // Animation out speed (ms)
            scrollText: "<i class='fa fa-chevron-up'></i>", // Text for element, can contain HTML
            scrollTitle: " ", // Set a custom <a> title if required. Defaults to scrollText
            scrollImg: 0, // Set true to use image
            activeOverlay: 0, // Set CSS color to display scrollUp active point, e.g "#00FFFF"
            zIndex: 9999 // Z-Index for the overlay
        });
    });
    /*===================================================================================*/
    /*	OTHER Function
     /*===================================================================================*/
    //底部图标弹框tooltip
    // $(function () {
    //     $('[data-toggle="tooltip"]').tooltip()
    // });
    // $(function () {
    //     $('[data-toggle="popover"]').popover()
    // });

    //加载完成后关闭加载框
     $(window).load(function() {
		setTimeout(function() {
			$('body').removeClass('loading-process noscroll');
		}, 100);
  });
    
  })(jQuery);

  }
}
</script>